
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/teamsreminder-financial-compliance-regulatory-deadlines",
      function () {
        return require("private-next-pages/article/teamsreminder-financial-compliance-regulatory-deadlines.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/teamsreminder-financial-compliance-regulatory-deadlines"])
      });
    }
  